import { IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledIconBackButton = styled(IconButton)<IconButtonProps>({
  position: 'absolute',
  left: '20px',
});
